// extracted by mini-css-extract-plugin
export default {"versatileTextSearchTypePopover":"VersatileTextSearch__versatileTextSearchTypePopover__AJFMu"};